<template>
<iframe-template
  :src='url'
  :width='previewSize'
  :visible='hasUrl' >

  <template slot="empty-text" >
    No website to preview. Please create or select a website
  </template>

  <template slot="iframe-toolbar" >
    <!-- {{url}}|{{previewUrl}} -->
    <v-btn-toggle tile group
      color="deep-purple accent-3"
      v-model="mobile" >

      <v-btn icon color='accent' :value='false' >
        <v-icon>mdi-monitor</v-icon>
      </v-btn>
      <v-btn icon :value='true' >
        <v-icon>mdi-cellphone</v-icon>
      </v-btn>

    </v-btn-toggle>
    <!-- me:<pre v-text='me' /> -->
  </template>

  <template slot="preferences" >
    <!-- <pre v-text="settings" /> -->
    <request-status :request='requests.websitecreate' @ok='get();showcreate=false' />
    <request-status :request='requests.destroy' @ok='get' />
    <v-card-title class='py-1 grey lighten-4 overline' >
      Websites
      <v-spacer/>
      <v-btn icon small
        class='ml-1'
        :loading='requests.website.loading'
        @click='get' >
        <v-icon small >mdi-reload</v-icon>
      </v-btn>
      <!-- <v-btn icon small
        :href='url' target='_blank' class='ml-1' >
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn> -->
    </v-card-title>
    <v-divider/>
    <v-list dense>

      <website-list-item
          :title="space.title"
          website-type="space"
          :data='space'
          :website='spaceWebsite'
          @click="listitemClicked"
          @destroy='destroy' />

      <v-divider/>
      <v-subheader class='overline pl-4 py-0 grey lighten-4' >Personal websites</v-subheader>
      <v-divider/>
      <template v-for='member in members' >
        <website-list-item
          :title="member.full_name"
          website-type="personal"
          :data='member'
          :website='getMemberWebsite(member)'
          :key='member.id'
          @click="listitemClicked"
          @destroy='destroy' />
        <v-divider :key="`div-${member.id}`" />
      </template>
    </v-list>

    <v-card-text >
      <copy-text-field v-if='url' :text-to-copy='url' />
    </v-card-text>

    <v-dialog v-model="showcreate" >
      <request-status :request="requests.websitecreate" />
      <v-card>
        <v-card-title class='overline py-1 grey lighten-4' >
          Create a {{websiteType}} website
          <v-spacer/>
          <v-btn icon @click='showcreate=false' >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-text-field
            label='Choose your free AppointmentGuru subdomain'
            v-model='slug'
            prefix='https://'
            suffix='.appt.guru' />

          <!-- <pre v-text="payload" /> -->

        </v-card-text>
        <v-card-actions >
          <v-spacer />
          <v-btn color='primary'
            :loading='requests.websitecreate.loading'
            @click='create' >Create website
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</iframe-template>
</template>
<script>
import IframeTemplate from '@/views/brand/digitalassets/IframeTemplate.vue'
import CopyTextField from '@/components/ui/CopyTextField.vue'
import WebsiteListItem from '@/components/listitems/WebsiteListItem.vue'

import {mapGetters} from 'vuex'
import {DEFAULT_MOBILE_PHONE_WIDTH} from '@/store/constants.js'

const SECTIONS = ['about', 'team', 'contacts', 'bookingform']
const WEBSITE_TYPES = {
  PERSONAL: 'personal',
  SPACE: 'space'
}
export default {
  name: 'Sites',
  components: {
    IframeTemplate,
    CopyTextField,
    WebsiteListItem
  },
  props: {
    value: { type: Object }
  },
  data () {
    return {
      selectedItem: null,
      selectedMember: null,
      mobile: true,
      showcreate: false,
      requests: {
        website: {
          resource: 'contentguru.websites',
          params: {
            ordering: '-space_id'
          }
        },
        websitecreate: {
          resource: 'contentguru.websites'
        },
        destroy: {
          resource: 'contentguru.websites'
        }
      },
      slug: '',
      websiteType: 'space',
      noWebsitesText: 'No websites found'
    }
  },
  mounted () {
    this.get()
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        this.selectedItem = 's=' + this.spaceId
      }
    },
    websites () {
      if (this.websites && this.websites.length > 0) {
        this.selectedItem = this.websites[0]
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['me', 'meId', 'getSpaceById', 'getMembers']),
    space () { return this.value },
    spaceId () { return this.getObjectPath(this.space, 'id') },
    settings () { return this.getObjectPath(this.space, 'settings') },
    websites () { return this.getObjectPath(this.requests, 'website.result.results', []) },
    subdomain () {
      return 'eatwell'
      // return this.getObjectPath(this.me, 'profile.sub_domain')
    },
    spaceWebsite () {
      return this.websites.find((site) => {
        return (parseInt(this.spaceId) === parseInt(site.space_id) && site.type === WEBSITE_TYPES.SPACE)
      })
    },
    url () {
      let url = this.getObjectPath(this.selectedItem, 'canonical_domain.name', false)
      if (url) {
        return 'https://' + url
      }
      return url
    },
    hasUrl () {
      if (this.url) { return true }
      return false
    },
    previewUrl () {
      // console.log(SERVICES)
      if (this.selectedItem && this.selectedItem.id) {
        let base = process.env.VUE_APP_CONTENTGURU_API_ROOT
        return base + '/preview/' + this.selectedItem.preview_key + '/'
      }
      return false
    },
    previewIsVisible () {
      if (this.selectedItem && this.selectedItem.id) { return true }
      return false
    },
    previewSize () {
      if (this.mobile) { return DEFAULT_MOBILE_PHONE_WIDTH }
      else { return '100%' }
    },
    payload () {
      let data = {
        type: this.websiteType,
        slug: this.slug,
        space_id: this.spaceId,
        published: true
      }
      if (this.websiteType === WEBSITE_TYPES.PERSONAL) {
        data.practitioner_id = this.selectedMember.id
      }
      if (this.websiteType === WEBSITE_TYPES.SPACE) {
        data.practitioner_id = this.meId
        data.sections = SECTIONS
      }
      return data
    },
    members () {
      if (this.spaceId) {
        return this.getMembers(this.spaceId)
      }
      return []
    }
  },
  methods: {
    get () {
      this.$request('get', this.requests.website)
    },
    create () {
      this.requests.websitecreate.data = this.payload
      this.$request('save', this.requests.websitecreate)
    },
    destroy (id) {
      this.requests.destroy.resourceId = id
      this.$request('delete', this.requests.destroy)
    },
    getMemberWebsite (member) {
      return this.websites.find((site) => {
        return (parseInt(member.id) === parseInt(site.practitioner_id) && site.type === WEBSITE_TYPES.PERSONAL)
      })
    },
    prepareCreate (type, data) {
      this.websiteType = type
      if (this.websiteType === WEBSITE_TYPES.PERSONAL) {
        this.slug = this.slugify(data.full_name)
        this.selectedMember = data
      }
      if (this.websiteType === WEBSITE_TYPES.SPACE) {
        this.slug = this.slugify(data.title)
      }
      this.showcreate = true
    },
    listitemClicked (item, website, websiteType) {
      if (website && website.id) {
        this.selectedItem = website
      } else {
        this.prepareCreate(websiteType, item)
      }
    },
    slugify(text) {
      if (text) {
        return text.toString().toLowerCase()
          .replace(/\s+/g, '-')           // Replace spaces with -
          .replace(/[^\w-]+/g, '')       // Remove all non-word chars
          .replace(/--+/g, '-')         // Replace multiple - with single -
          .replace(/^-+/, '')             // Trim - from start of text
          .replace(/-+$/, '');            // Trim - from end of text
      }
      return ''
    }
  }
}
</script>
